<mat-sidenav-container class="dashboard-container" [autosize]="!isHandset()">
  <mat-sidenav #sidenav class="dashboard-sidenav" [class.is-collapsed]="!isHandset() && isCollapsed()"
    [mode]="isHandset() ? 'over' : 'side'" [opened]="!isHandset()">
    <div class="brand hand" (click)="goHome()">
      <img class="brand-logo" src="/snf-logo-mark.png" alt="SNF" />
      <span>{{ appTitle }}</span>
    </div>
    <!-- 
    @if (userName()) {
    <div class="brand hand" (click)="goProfile()">
      <mat-icon>account_circle</mat-icon>
      <span>{{ userName() }}</span>
    </div>
    } @else {
    <div class="brand">
      <mat-icon>account_circle</mat-icon>
      <span>Guest</span>
    </div>
    } -->

    <mat-nav-list>
      @for (item of navItems; track item.route) {
      <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link" #activeLink="routerLinkActive"
        [activated]="activeLink.isActive" [routerLinkActiveOptions]="{ exact: true }" (click)="closeOnMobile()"
        [attr.title]="!isHandset() && isCollapsed() ? item.label : null">
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        <span matListItemTitle>{{ item.label }}</span>
      </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="topbar">
      @if (isHandset()) {
      <button mat-icon-button type="button" aria-label="Open sidenav" (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      } @else {
      <button mat-icon-button type="button" [attr.aria-label]="isCollapsed() ? 'Expand sidenav' : 'Collapse sidenav'"
        (click)="toggleDesktopSidenav()">
        @if (isCollapsed()) {
        <mat-icon>menu</mat-icon>
        } @else {
        <mat-icon>menu_open</mat-icon>
        }
      </button>
      }
      <span>{{ pageTitle() }}</span>
      <span class="toolbar-spacer"></span>
      <button mat-icon-button type="button" class="theme-toggle" (click)="toggleThemeMode()"
        [attr.aria-label]="isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'">
        @if (isDarkMode()) {
        <mat-icon>light_mode</mat-icon>
        } @else {
        <mat-icon>dark_mode</mat-icon>
        }
      </button>
      <button mat-button type="button" class="user-trigger" [matMenuTriggerFor]="userMenu" aria-label="Open user menu"
        [disabled]="authLoading()">
        <div class="user-icon-div">
          <mat-icon class="user-icon">account_circle</mat-icon>
          <span>{{ userName() }}</span>
          <mat-icon class="user-chevron">arrow_drop_down</mat-icon>
        </div>
      </button>
    </mat-toolbar>

    <main class="content">
      <ng-content></ng-content>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-menu #userMenu="matMenu" class="user-menu-panel" xPosition="before" yPosition="below" [overlapTrigger]="false">
  <div class="user-menu-header">
    <mat-icon class="user-avatar">account_circle</mat-icon>
    <div class="user-details">
      @if (authLoading()) {
      <div class="user-name">Loading…</div>
      } @else if (userName()) {
      <div class="user-name">{{ userName() }}</div>
      } @else { <div class="user-name">Guest</div>
      }

      <div class="user-email">{{ userEmail() }}</div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <button mat-menu-item type="button" (click)="goProfile()">
    <mat-icon>person</mat-icon>
    <span>Profile</span>
  </button>

  <button mat-menu-item type="button" (click)="goHome()">
    <mat-icon>home</mat-icon>
    <span>Home</span>
  </button>

  <div class="logout-wrapper">
    <button mat-flat-button color="primary" type="button" class="logout-button" (click)="logout()">
      <mat-icon>power_settings_new</mat-icon>
      <span>Logout</span>
    </button>
  </div>
</mat-menu>
